import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { LayoutGrid, FolderOpen, Settings, Headphones } from 'lucide-react'
import { setFooterNavMode } from '../../store/slices/uiSlice'
import { FOOTER_NAV_MODES, resolveFooterNavMode } from '../../config/footerNavConfig'
import './FooterMenu.css'

const FOOTER_ITEMS = [
  { mode: 'applications', label: 'App', icon: LayoutGrid },
  { mode: 'masters', label: 'Masters', icon: FolderOpen },
  { mode: 'settings', label: 'Settings', icon: Settings },
  { mode: 'support', label: 'Support', icon: Headphones }
]

const FooterMenu = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { footerNavMode, sidebarCollapsed } = useSelector((state) => state.ui)

  useEffect(() => {
    const mode = resolveFooterNavMode(location.pathname, location.search)
    if (mode !== footerNavMode) {
      dispatch(setFooterNavMode(mode))
    }
  }, [location.pathname, location.search, dispatch, footerNavMode])

  const handleSelect = (mode) => {
    const config = FOOTER_NAV_MODES[mode]
    if (!config) return
    dispatch(setFooterNavMode(mode))
    navigate(config.defaultPath)
  }

  return (
    <div className={`sidebar-footer-menu ${sidebarCollapsed ? 'collapsed' : ''}`}>
      <nav className="footer-menu" aria-label="Application sections">
        {FOOTER_ITEMS.map(({ mode, label, icon: Icon }, index) => {
          const isActive =
            footerNavMode === mode ||
            (mode === 'applications' && footerNavMode === 'reports')
          return (
            <React.Fragment key={mode}>
              {index > 0 && <div className="footer-menu-divider" aria-hidden="true" />}
              <button
                type="button"
                className={`footer-menu-item ${isActive ? 'active' : ''}`}
                onClick={() => handleSelect(mode)}
                aria-current={isActive ? 'page' : undefined}
                title={label}
              >
                <Icon size={20} strokeWidth={1.75} className="footer-menu-icon" />
                {!sidebarCollapsed && (
                  <span className="footer-menu-label">{label}</span>
                )}
              </button>
            </React.Fragment>
          )
        })}
      </nav>
    </div>
  )
}

export default FooterMenu
